(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_section-header"] && !Shopify.designMode) return;
  try {
    class SectionHeaderControls extends HTMLElement {
    connectedCallback() {
      // The rail this drives is a sibling of the header, not a child, so it
      // is found through the section rather than by traversing up.
      this.rail = this.closest('.shopify-section')?.querySelector('[data-carousel-rail]');
      if (!this.rail) return;

      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');

      this.onPrev = () => this.#scrollBy(-1);
      this.onNext = () => this.#scrollBy(1);
      this.sync = () => this.#sync();

      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);
      this.rail.addEventListener('scroll', this.sync, { passive: true });

      // Whether the rail overflows at all changes with the breakpoint (a
      // layout stacked at one width is a carousel at another) and with how
      // many tiles it holds, so it is re-measured rather than decided once.
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.sync);
        this.resizeObserver.observe(this.rail);
      }

      if ('MutationObserver' in window) {
        this.mutationObserver = new MutationObserver(this.sync);
        this.mutationObserver.observe(this.rail, { childList: true, subtree: true });
      }

      window.addEventListener('load', this.sync);
      this.#sync();
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.rail?.removeEventListener('scroll', this.sync);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      window.removeEventListener('load', this.sync);
    }

    #scrollBy(direction) {
      // One cell's width per press, measured off the rail so the step stays
      // right however many columns the merchant chose. Shopify's block
      // wrappers can be display:contents and report no box, so skip past any
      // that measure zero rather than trusting the first child.
      const cell = Array.from(this.rail.children)
        .flatMap((child) => (child.getBoundingClientRect().width ? [child] : Array.from(child.children)))
        .find((node) => node.getBoundingClientRect().width > 0);

      const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
      const step = cell ? cell.getBoundingClientRect().width + gap : this.rail.clientWidth;
      this.rail.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    #sync() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;

      // Nothing to scroll — a stacked grid, or every tile already in view —
      // means nothing for the arrows to do, so they get out of the way.
      this.hidden = max <= 1;
      if (this.hidden) return;

      if (this.prev) this.prev.disabled = this.rail.scrollLeft <= 1;
      if (this.next) this.next.disabled = this.rail.scrollLeft >= max - 1;
    }
  }

  if (!customElements.get('section-header-controls')) {
    customElements.define('section-header-controls', SectionHeaderControls);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    class MenuBlock extends HTMLElement {
    connectedCallback() {
      const toggle = this.querySelector('[data-menu-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', () => {
        // The media query decides whether collapsing applies at all; below it
        // the caret is hidden and the list is always shown, so a stray click
        // here would only flip an attribute nothing reads.
        const open = this.toggleAttribute('open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }
  }

  if (!customElements.get('menu-block')) {
    customElements.define('menu-block', MenuBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    // Quantity stepper, delegated so it survives section re-renders.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-qty-step]');
    if (!button) return;

    const wrapper = button.closest('.buy-buttons__stepper');
    const input = wrapper && wrapper.querySelector('[data-product-quantity]');
    if (!input) return;

    const step = Number(input.step) || 1;
    const min = Number(input.min) || 1;
    const next = (Number(input.value) || min) + Number(button.dataset.qtyStep) * step;

    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /**
   * The recipient fields only matter once the buyer says the card is a gift,
   * so they stay out of the way until the checkbox is ticked.
   */
  class GiftCardRecipient extends HTMLElement {
    connectedCallback() {
      const toggle = this.querySelector('[data-recipient-toggle]');
      const fields = this.querySelector('[data-recipient-fields]');
      if (!toggle || !fields) return;

      const sync = () => {
        fields.hidden = !toggle.checked;
      };

      toggle.addEventListener('change', sync);
      sync();
    }
  }

  if (!customElements.get('gift-card-recipient')) {
    customElements.define('gift-card-recipient', GiftCardRecipient);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-complementary"] && !Shopify.designMode) return;
  try {
    class ProductComplementary extends HTMLElement {
    connectedCallback() {
      // Recommendations are only available through the recommendations API,
      // so fetch them once the product page has rendered.
      if (this.dataset.loaded) return;
      this.dataset.loaded = 'true';

      fetch(this.dataset.url)
        .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const list = doc.querySelector('.complementary__list');
          const target = this.querySelector('[data-complementary-target]');
          if (!target) return;

          if (!list) {
            this.#reportEmpty();
            return;
          }

          target.appendChild(list);
          const heading = this.querySelector('[data-complementary-heading]');
          if (heading) heading.hidden = false;
          this.#startCarousel(list);
        })
        .catch(() => {
          this.#reportEmpty();
        });
    }

    // The list only exists once the recommendations have come back, so the
    // carousel's arrows and scroll bar are wired up here rather than on
    // connect — by which point there was no row to measure.
    #startCarousel(rail) {
      // The shared indicator went looking for its rail when it connected,
      // before this list existed. Replacing it with a fresh copy of itself is
      // the cheapest way to make it measure again.
      const indicator = this.querySelector('[data-complementary-indicator]');
      if (indicator) indicator.replaceWith(indicator.cloneNode(true));

      const prev = this.querySelector('[data-complementary-prev]');
      const next = this.querySelector('[data-complementary-next]');
      if (!prev || !next) return;

      // Which way a press has to move the rail: under RTL the row fills from
      // the right and scrollLeft runs negative, so the sign flips.
      const sign = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;

      const step = (towards) => {
        const card = rail.firstElementChild;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        const width = card ? card.getBoundingClientRect().width + gap : rail.clientWidth;
        rail.scrollBy({ left: width * towards * sign, behavior: 'smooth' });
      };

      const sync = () => {
        const max = rail.scrollWidth - rail.clientWidth;

        // Nothing to scroll — every product already in view — means nothing
        // for the arrows to do, so they stay out of the column.
        prev.hidden = max <= 1;
        next.hidden = max <= 1;
        if (max <= 1) return;

        // Measured as a distance travelled, which holds whichever sign the
        // browser gives scrollLeft under RTL.
        const travelled = Math.abs(rail.scrollLeft);
        prev.disabled = travelled <= 1;
        next.disabled = travelled >= max - 1;
      };

      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      rail.addEventListener('scroll', sync, { passive: true });

      // Whether the row overflows at all changes with the width of the column
      // it sits in, so it is re-measured rather than decided once.
      if ('ResizeObserver' in window) {
        new ResizeObserver(sync).observe(rail);
      }

      sync();
    }

    // Nothing came back. Shoppers see an empty block, which is what the
    // merchant asked for by not setting complementary products; the editor
    // gets told why so it does not look like the block failed to load.
    #reportEmpty() {
      if (!this.dataset.editor) return;
      const notice = this.querySelector('[data-complementary-empty]');
      if (notice) notice.hidden = false;
    }
  }

  if (!customElements.get('product-complementary')) {
    customElements.define('product-complementary', ProductComplementary);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-share"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-share-copy]');
    if (!button) return;

    const url = button.dataset.url;
    const label = button.querySelector('[data-share-label]');

    // Prefer the native share sheet on touch devices; fall back to clipboard.
    if (navigator.share) {
      try {
        await navigator.share({ url });
        return;
      } catch (error) {
        /* Dismissed — fall through to copying. */
      }
    }

    try {
      await navigator.clipboard.writeText(url);
      if (!label) return;
      const original = label.textContent;
      label.textContent = button.dataset.copied;
      setTimeout(() => {
        label.textContent = original;
      }, 2000);
    } catch (error) {
      /* Clipboard blocked; nothing useful to do. */
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    // Delegated so it survives section re-renders and works for every size
  // guide trigger on the page (main product, quick view, etc.).
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-size-guide-trigger]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.sizeGuideDialog);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-size-guide-close]');
    if (closeButton) {
      const dialog = closeButton.closest('[data-size-guide-dialog-el]');
      if (dialog) dialog.close();
      return;
    }

    // Clicking the backdrop (the dialog element itself, outside its content
    // box) closes it, matching the quick-view modal's overlay-click pattern.
    const dialog = event.target.closest('[data-size-guide-dialog-el]');
    if (dialog && event.target === dialog) dialog.close();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["timer"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(number) {
      return String(number).padStart(2, '0');
    }

    function render(el, remainingMs) {
      const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      el.textContent = days > 0
        ? `${days}:${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
        : `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }

    function initTimer(el) {
      // A JS property, not a data attribute: `cloneNode` copies attributes,
      // so a copied timer would arrive looking already started and never
      // tick. The announcement bar copies its messages to fill the marquee.
      if (el.timerRunning) return;
      el.timerRunning = true;

      const raw = el.dataset.endTime;
      if (!raw) return;

      const endTime = new Date(raw).getTime();
      if (Number.isNaN(endTime)) return;

      function tick() {
        const remaining = endTime - Date.now();
        render(el, remaining);

        if (remaining <= 0) {
          // Freeze on 00:00:00 — no hiding, no message swap.
          clearInterval(intervalId);
        }
      }

      tick();
      const intervalId = setInterval(tick, 1000);
    }

    function init(root) {
      (root || document).querySelectorAll('[data-end-time]').forEach(initTimer);
    }

    // Exposed so anything that copies a timer into the page can start the
    // copy ticking — otherwise it sits frozen at whatever second it was
    // copied on, beside an original that keeps counting.
    window.PixelBearTimers = { init: init };

    init(document);
  })();
  } catch(e) { console.error(e); }
})();

})();
